import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const heroBg =
  "linear-gradient(140deg, rgba(7, 12, 25, 0.93), rgba(8, 47, 73, 0.9), rgba(15, 23, 42, 0.9)), url('/backroundlanding.png')";

export default function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from || "/app";

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setSubmitting(true);
      await signup({
        email: email.trim(),
        password,
        fullName: fullName.trim(),
        companyName: companyName.trim(),
      });
      try {
        window.sessionStorage.setItem("cv.justLoggedIn", "1");
      } catch {
        // ignore storage failures
      }
      navigate(from, { replace: true });
    } catch (err) {
      setError(err?.message || "Unable to create account. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        backgroundImage: heroBg,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="w-full max-w-md rounded-3xl border-2 border-sky-200/35 px-6 py-8 shadow-2xl shadow-black/50 backdrop-blur"
        style={{
          background:
            "linear-gradient(145deg, rgba(13,26,42,0.9), rgba(7,16,30,0.88))",
          boxShadow:
            "0 25px 60px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.05)",
        }}
      >
        <div className="mb-6 flex items-center justify-center">
          <img
            src="/logo.png"
            alt="ClaimSupplement"
            className="h-24 w-auto drop-shadow-[0_14px_40px_rgba(14,165,233,0.45)]"
            draggable={false}
          />
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="space-y-1.5">
            <label className="block text-xs font-medium text-slate-200">
              Full name
            </label>
            <input
              type="text"
              autoComplete="name"
              className="w-full rounded-xl border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-50 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none focus:ring-1 focus:ring-cyan-400/80"
              placeholder="Jane Doe"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <label className="block text-xs font-medium text-slate-200">
              Company
            </label>
            <input
              type="text"
              autoComplete="organization"
              className="w-full rounded-xl border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-50 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none focus:ring-1 focus:ring-cyan-400/80"
              placeholder="Altieria Adjusters"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <label className="block text-xs font-medium text-slate-200">
              Work email
            </label>
            <input
              type="email"
              autoComplete="email"
              required
              className="w-full rounded-xl border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-50 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none focus:ring-1 focus:ring-cyan-400/80"
              placeholder="you@firm.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <label className="block text-xs font-medium text-slate-200">
              Password
            </label>
            <input
              type="password"
              autoComplete="new-password"
              required
              className="w-full rounded-xl border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-50 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none focus:ring-1 focus:ring-cyan-400/80"
              placeholder="Create a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <label className="block text-xs font-medium text-slate-200">
              Confirm password
            </label>
            <input
              type="password"
              autoComplete="new-password"
              required
              className="w-full rounded-xl border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-50 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none focus:ring-1 focus:ring-cyan-400/80"
              placeholder="Re-enter password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </div>

          {error && (
            <div className="rounded-xl border border-red-500/40 bg-red-500/10 px-3 py-2 text-xs text-red-200">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="group mt-2 flex w-full items-center justify-center text-sm font-semibold text-cyan-100 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/80 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <span className="relative inline-flex items-center after:content-[''] after:absolute after:-bottom-1 after:left-0 after:h-[2px] after:w-full after:origin-left after:scale-x-0 after:rounded-full after:bg-gradient-to-r after:from-cyan-300 after:via-sky-300 after:to-emerald-300 after:transition-transform after:duration-200 after:ease-out group-hover:after:scale-x-100">
              {submitting ? "Creating account..." : "Create account"}
            </span>
          </button>
        </form>

        <div className="mt-4 flex flex-wrap items-center justify-between gap-2 text-[11px] text-slate-400">
          <Link to="/login" className="hover:text-amber-300 transition-colors">
            Already have an account? Sign in
          </Link>

          <Link to="/" className="hover:text-amber-300 transition-colors">
            Back to landing page
          </Link>
        </div>
      </div>
    </div>
  );
}
